import { useEffect, useState } from "react";

let counter = 0;
const nextId = () => {
  counter += 1;
  return `band-${counter}`;
};

const freshIds = (count) => Array.from({ length: count }, nextId);

/**
 * A stable identity per pricing band, so React keys never fall back to the
 * array index.
 *
 * The bands themselves are plain arrays of numbers with no id of their own, and
 * the position of a band is what gives it meaning, so the ids are tracked
 * alongside the rows instead:
 *  - `added` appends one id, leaving every existing band on its own id;
 *  - `removed` drops that one id, so the bands below keep the inputs they
 *    already had rather than inheriting the removed band's figures;
 *  - if the count changes from outside (a reset, a restored version, or a
 *    switch to another service) the list is rebuilt from scratch.
 */
export function useBandIds(count) {
  const [ids, setIds] = useState(() => freshIds(count));

  useEffect(() => {
    setIds((current) => (current.length === count ? current : freshIds(count)));
  }, [count]);

  return {
    ids,
    added: () => setIds((current) => [...current, nextId()]),
    removed: (index) => setIds((current) => current.filter((_id, i) => i !== index)),
  };
}
